import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import { usePageMeta } from '@/hooks/usePageMeta';

const SCOPE = [
  {
    icon: 'ri-film-line',
    title: '影视作品库',
    desc: '系统整理神宫寺奈绪出演的电影、电视剧与综艺，包含剧情简介、演职员与基础资料。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '资讯动态',
    desc: '按时间倒序汇总最新娱乐资讯与作品消息，帮助粉丝第一时间掌握演艺动向。',
  },
  {
    icon: 'ri-user-star-line',
    title: '演艺资料',
    desc: '涵盖作品类型、年份、播出平台与题材标签，形成清晰可检索的资料体系。',
  },
];

export default function About() {
  usePageMeta({
    title: '关于本站 - 神宫寺奈绪影视内容站',
    description:
      '了解神宫寺奈绪影视内容站的定位与内容范围：专注整理影视作品、新闻动态与演艺资料，为粉丝提供全面、清晰的信息服务。',
    keywords: '神宫寺奈绪,关于本站,影视内容站,演艺资料',
  });

  return (
    <div className="w-full">
      <section className="px-4 md:px-6 pt-8 md:pt-12 pb-6 md:pb-8 bg-background-100 border-b border-background-200">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于' }]} />
        <h1 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
          关于本站
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-2xl">
          专注神宫寺奈绪相关影视作品、新闻动态与演艺资料的粉丝向内容站。
        </p>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              网站介绍
            </h2>
            <div className="mt-5 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                神宫寺奈绪影视内容站是一个面向粉丝与影视爱好者的信息聚合站点。我们围绕神宫寺奈绪的影视作品、电视剧、电影、综艺节目，
                以及相关新闻动态与演艺资料进行系统整理，力求提供全面且清晰的信息服务。
              </p>
              <p>
                网站以现代门户风格呈现内容，通过分类检索、多维筛选与关联推荐，帮助用户便捷地浏览作品介绍、获取最新娱乐资讯，
                并深入了解作品的详细资料与幕后动态。
              </p>
              <p className="text-foreground-500 text-xs md:text-sm">
                温馨提示：本站为演示站点，所有作品、资讯与演艺资料均为虚构示例，仅用于展示内容组织与浏览体验，不代表任何真实信息。
              </p>
            </div>

            <div className="mt-8 rounded-lg overflow-hidden aspect-video bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=artistic%20minimal%20desk%20with%20film%20notebook%20and%20warm%20orange%20lamp%20against%20deep%20blue%20wall%2C%20editorial%20still%20life%2C%20soft%20lighting%2C%20clean%20composition&width=1200&height=675&seq=about-banner-01&orientation=landscape"
                alt="关于神宫寺奈绪影视内容站"
                title="神宫寺奈绪影视内容站 演艺资料与作品介绍"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              内容范围
            </h2>
            <div className="mt-5 space-y-4">
              {SCOPE.map((s) => (
                <div
                  key={s.title}
                  className="flex gap-4 p-4 md:p-5 bg-background-100 border border-background-200 rounded-lg"
                >
                  <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-xl shrink-0">
                    <i className={s.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">{s.title}</h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <h2 className="mt-10 font-heading text-xl md:text-2xl font-bold text-foreground-950">
              联系方式
            </h2>
            <div className="mt-5 p-5 md:p-6 bg-primary-950 rounded-lg text-background-100">
              <p className="text-sm text-background-200/80 leading-relaxed">
                如对本站内容有任何建议、反馈或内容补充，欢迎通过以下方式联系我们。我们会在工作日内查看并回复。
              </p>
              <div className="mt-5 space-y-3 text-sm">
                <p className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-accent-400 shrink-0">
                    <i className="ri-mail-line"></i>
                  </span>
                  contact@nanao-film.demo
                </p>
                <p className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-accent-400 shrink-0">
                    <i className="ri-time-line"></i>
                  </span>
                  周一至周五 10:00 - 18:00
                </p>
                <p className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-accent-400 shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </span>
                  线上内容站 · 无实体办公地址
                </p>
              </div>
              <Link
                to="/category"
                className="mt-6 inline-flex px-6 h-11 rounded-md bg-accent-500 hover:bg-accent-600 text-white text-sm font-medium items-center gap-2 whitespace-nowrap transition-colors"
              >
                <i className="ri-movie-2-line"></i>
                浏览影视作品
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}